export interface Anime {
  id: string;
  title: string;
  cover: string;
  banner: string;
  genres: string[];
  region: string;
  year: number;
  episodes: number;
  status: string;
  rating: number;
  views: number;
  studio: string;
  description: string;
  featured: boolean;
}

export const animeList: Anime[] = [
  {
    id: "star-train",
    title: "星海列车的旅人",
    cover: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20illustration%20of%20a%20young%20traveler%20standing%20on%20the%20deck%20of%20a%20glowing%20star%20train%20gliding%20through%20a%20purple%20galaxy%2C%20cel%20shaded%20poster%20art%2C%20vibrant%20colors%2C%20detailed%20character%20design%2C%20soft%20lighting%2C%20anime%20movie%20key%20visual&width=600&height=800&seq=anime-cover-01&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20cinematic%20scene%20of%20a%20golden%20star%20train%20flying%20through%20a%20nebula%20at%20night%2C%20wide%20epic%20landscape%2C%20cel%20shaded%20illustration%2C%20warm%20pink%20and%20orange%20glow%2C%20dreamy%20atmosphere%2C%20anime%20background%20art&width=1600&height=900&seq=anime-banner-01&orientation=landscape",
    genres: ["冒险", "奇幻", "治愈"],
    region: "日本",
    year: 2024,
    episodes: 24,
    status: "更新至第 12 集",
    rating: 9.2,
    views: 18360000,
    studio: "星屑动画工作室",
    description:
      "少年凛在一次月食之夜登上了一列只在星辰间行驶的神秘列车，从此踏上了穿越星海的旅程。列车停靠的每一站都是一个截然不同的世界，他在这里遇见了形形色色的旅人，也在一次次的告别中慢慢寻找回家的方向。作品以温柔细腻的笔触描绘旅途中的相遇与成长，是年度最受好评的治愈系奇幻动画。",
    featured: true,
  },
  {
    id: "sakura-love",
    title: "樱色恋习曲",
    cover: "https://readdy.ai/api/search-image?query=anime%20romance%20key%20visual%20of%20a%20high%20school%20boy%20and%20girl%20under%20cherry%20blossom%20trees%2C%20pink%20petals%20falling%2C%20soft%20pastel%20colors%2C%20cel%20shaded%20poster%20illustration%2C%20warm%20spring%20lighting%2C%20detailed%20school%20uniform&width=600&height=800&seq=anime-cover-02&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20scenic%20background%20of%20a%20Japanese%20high%20school%20campus%20in%20spring%20with%20full%20blooming%20cherry%20blossom%20trees%2C%20soft%20pink%20petals%20floating%2C%20warm%20golden%20sunlight%2C%20cel%20shaded%20illustration%2C%20romantic%20atmosphere&width=1600&height=900&seq=anime-banner-02&orientation=landscape",
    genres: ["恋爱", "校园", "喜剧"],
    region: "日本",
    year: 2024,
    episodes: 12,
    status: "更新至第 8 集",
    rating: 8.7,
    views: 12480000,
    studio: "花音制作",
    description:
      "转入樱丘高中的春天，内向的男主角遇见了总爱在音乐教室弹钢琴的少女。一段从误会开始的青春物语，在樱花纷飞的季节里悄然萌芽。作品用轻松幽默的日常与恰到好处的悸动，勾勒出属於十七岁的青涩心动。",
    featured: true,
  },
  {
    id: "mechanical-dawn",
    title: "机械之心的黎明",
    cover: "https://readdy.ai/api/search-image?query=anime%20mecha%20key%20visual%20of%20a%20giant%20robot%20standing%20in%20a%20futuristic%20ruined%20city%20at%20dawn%2C%20orange%20sunrise%20sky%2C%20dramatic%20lighting%2C%20cel%20shaded%20poster%20art%2C%20detailed%20mechanical%20design&width=600&height=800&seq=anime-cover-03&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20epic%20scene%20of%20a%20piloted%20mecha%20robot%20standing%20against%20a%20sunrise%20over%20a%20ruined%20futuristic%20city%2C%20wide%20cinematic%20landscape%2C%20cel%20shaded%20illustration%2C%20orange%20and%20teal%20contrast%2C%20dramatic%20sky&width=1600&height=900&seq=anime-banner-03&orientation=landscape",
    genres: ["科幻", "热血", "机战"],
    region: "日本",
    year: 2023,
    episodes: 24,
    status: "已完结",
    rating: 9.0,
    views: 21540000,
    studio: "铁翼工作室",
    description:
      "在被机械军团席卷的未来，少年驾驶员亚伦被选中操控最后一台原型机「黎明」。当钢铁的巨人与少年的信念碰撞，一场关乎人类存亡的反击就此展开。硬核的机战演出与对战争与人性的深刻刻画，让它成为年度科幻动画的口碑之作。",
    featured: true,
  },
  {
    id: "spirit-fox",
    title: "灵狐少年谭",
    cover: "https://readdy.ai/api/search-image?query=anime%20fantasy%20key%20visual%20of%20a%20boy%20with%20a%20white%20nine%20tailed%20fox%20spirit%20beside%20him%20in%20an%20ancient%20Chinese%20village%2C%20ink%20wash%20style%20colors%2C%20cel%20shaded%20poster%20art%2C%20mystical%20glow&width=600&height=800&seq=anime-cover-04&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20scenic%20background%20of%20an%20ancient%20Chinese%20mountain%20village%20with%20lanterns%20and%20mist%2C%20a%20giant%20white%20fox%20spirit%20in%20the%20sky%2C%20cel%20shaded%20illustration%2C%20warm%20golden%20and%20green%20tones%2C%20fantasy%20atmosphere&width=1600&height=900&seq=anime-banner-04&orientation=landscape",
    genres: ["奇幻", "热血", "古风"],
    region: "国产",
    year: 2024,
    episodes: 20,
    status: "更新至第 16 集",
    rating: 8.5,
    views: 9860000,
    studio: "青丘动画",
    description:
      "少年阿黎意外与一只被封印千年的九尾灵狐订下契约，从此卷入人妖两界的纷争。他必须在守护家园与解开诅咒之间做出抉择。作品以浓郁的东方古风美术与流畅的打斗分镜，呈现出属于国漫的独特浪漫。",
    featured: false,
  },
  {
    id: "midnight-diner",
    title: "深夜食堂物语",
    cover: "https://readdy.ai/api/search-image?query=anime%20slice%20of%20life%20key%20visual%20of%20a%20cozy%20small%20late%20night%20diner%20with%20warm%20lantern%20light%2C%20steaming%20bowls%20of%20food%2C%20soft%20warm%20tones%2C%20cel%20shaded%20poster%20illustration%2C%20healing%20atmosphere&width=600&height=800&seq=anime-cover-05&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20warm%20cozy%20Japanese%20alley%20at%20night%20with%20glowing%20small%20diner%2C%20rainy%20street%20reflections%2C%20cel%20shaded%20illustration%2C%20warm%20orange%20lantern%20light%2C%20nostalgic%20mood&width=1600&height=900&seq=anime-banner-05&orientation=landscape",
    genres: ["治愈", "日常", "美食"],
    region: "日本",
    year: 2022,
    episodes: 12,
    status: "已完结",
    rating: 8.9,
    views: 7430000,
    studio: "暖灯社",
    description:
      "在城市角落的一家只在深夜营业的小食堂里，形形色色的客人带着各自的故事推门而入。一碗热汤、一份家常菜，治愈着每一个疲惫的夜晚。没有激烈的剧情，只有细水长流的人间烟火。",
    featured: false,
  },
  {
    id: "sword-shadow",
    title: "剑影孤城",
    cover: "https://readdy.ai/api/search-image?query=anime%20wuxia%20key%20visual%20of%20a%20young%20swordsman%20holding%20a%20long%20sword%20on%20a%20cliff%20above%20misty%20mountains%2C%20dramatic%20wind%2C%20cel%20shaded%20poster%20art%2C%20ink%20splash%20accents%2C%20cool%20blue%20gray%20palette&width=600&height=800&seq=anime-cover-06&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20epic%20wuxia%20scene%20of%20a%20lonely%20ancient%20city%20on%20misty%20mountains%20with%20a%20swordsman%20silhouette%2C%20traditional%20Chinese%20architecture%2C%20cel%20shaded%20illustration%2C%20moody%20gray%20and%20gold%20tones&width=1600&height=900&seq=anime-banner-06&orientation=landscape",
    genres: ["热血", "武侠", "古风"],
    region: "国产",
    year: 2023,
    episodes: 26,
    status: "已完结",
    rating: 8.3,
    views: 8120000,
    studio: "寒江工作室",
    description:
      "背负灭门之仇的少年独自踏上江湖，在孤城中磨砺剑术，也逐渐看清仇恨背后的真相。刀光剑影之间，是少年的成长，也是江湖的宿命。写意的水墨打斗与厚重的江湖气，构成一部耐人寻味的武侠群像剧。",
    featured: false,
  },
  {
    id: "tennis-ace",
    title: "网球王牌",
    cover: "https://readdy.ai/api/search-image?query=anime%20sports%20key%20visual%20of%20a%20high%20school%20tennis%20player%20mid%20swing%20on%20a%20sunny%20court%2C%20dynamic%20action%20pose%2C%20cel%20shaded%20poster%20art%2C%20blue%20sky%2C%20energetic%20lighting&width=600&height=800&seq=anime-cover-07&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20school%20tennis%20court%20at%20golden%20hour%20with%20cheering%20crowd%20silhouettes%2C%20dynamic%20motion%20lines%2C%20cel%20shaded%20illustration%2C%20warm%20sunset%20light&width=1600&height=900&seq=anime-banner-07&orientation=landscape",
    genres: ["运动", "热血", "校园"],
    region: "日本",
    year: 2021,
    episodes: 50,
    status: "已完结",
    rating: 8.6,
    views: 15670000,
    studio: "晴空制作",
    description:
      "身材矮小却天赋异禀的少年立志成为全国第一的网球选手。从被嘲笑的替补到队伍的王牌，他用汗水与不服输的意志书写青春。紧张刺激的比赛演出与热血沸腾的成长故事，让这部作品成为运动番的经典。",
    featured: false,
  },
  {
    id: "dream-bureau",
    title: "梦境调查局",
    cover: "https://readdy.ai/api/search-image?query=anime%20mystery%20key%20visual%20of%20a%20detective%20in%20a%20surreal%20dream%20world%20of%20floating%20doors%20and%20clocks%2C%20cel%20shaded%20poster%20art%2C%20deep%20indigo%20and%20gold%20tones%2C%20surrealist%20composition&width=600&height=800&seq=anime-cover-08&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20surreal%20background%20of%20an%20endless%20dream%20corridor%20with%20floating%20clocks%20and%20staircases%2C%20cel%20shaded%20illustration%2C%20mysterious%20purple%20and%20gold%20lighting%2C%20surreal%20atmosphere&width=1600&height=900&seq=anime-banner-08&orientation=landscape",
    genres: ["悬疑", "奇幻", "推理"],
    region: "日本",
    year: 2024,
    episodes: 13,
    status: "已完结",
    rating: 8.8,
    views: 10240000,
    studio: "幻视工房",
    description:
      "在一个人们可以共享梦境的近未来，调查局专门处理发生在梦里的离奇案件。新人调查员与被降职的天才搭档，携手潜入一个个光怪陆离的梦境寻找真相。烧脑的谜题设计与超现实的美术风格令人眼前一亮。",
    featured: false,
  },
  {
    id: "dessert-magic",
    title: "甜品魔法屋",
    cover: "https://readdy.ai/api/search-image?query=anime%20pastel%20key%20visual%20of%20a%20cheerful%20girl%20baking%20colorful%20desserts%20in%20a%20magical%20pink%20kitchen%2C%20sparkles%20and%20sweets%20floating%2C%20cel%20shaded%20poster%20art%2C%20soft%20pastel%20tones&width=600&height=800&seq=anime-cover-09&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20whimsical%20pastel%20dessert%20shop%20interior%20with%20cakes%20and%20candy%20decorations%2C%20cel%20shaded%20illustration%2C%20soft%20pink%20and%20cream%20colors%2C%20sweet%20dreamy%20mood&width=1600&height=900&seq=anime-banner-09&orientation=landscape",
    genres: ["治愈", "校园", "美食"],
    region: "日本",
    year: 2023,
    episodes: 12,
    status: "已完结",
    rating: 8.2,
    views: 5680000,
    studio: "糖果社",
    description:
      "继承祖母甜品店的少女发现店里的甜品都藏着小小的魔法。为了守护这家承载回忆的小店，她和伙伴们一起努力研发新品、招待客人。甜甜的画风与温暖的日常故事，是治愈系爱好者的心头好。",
    featured: false,
  },
  {
    id: "sky-wings",
    title: "苍穹之翼",
    cover: "https://readdy.ai/api/search-image?query=anime%20adventure%20key%20visual%20of%20a%20young%20pilot%20flying%20with%20a%20glider%20above%20floating%20islands%2C%20blue%20sky%20and%20clouds%2C%20cel%20shaded%20poster%20art%2C%20adventurous%20spirit%2C%20warm%20sunlight&width=600&height=800&seq=anime-cover-10&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20vast%20floating%20islands%20in%20a%20bright%20sky%20with%20air%20ships%2C%20epic%20landscape%2C%20cel%20shaded%20illustration%2C%20clear%20blue%20and%20white%20clouds%2C%20sense%20of%20adventure&width=1600&height=900&seq=anime-banner-10&orientation=landscape",
    genres: ["冒险", "科幻", "热血"],
    region: "欧美",
    year: 2022,
    episodes: 16,
    status: "已完结",
    rating: 8.4,
    views: 6930000,
    studio: "Skybound Studio",
    description:
      "在漂浮于云海之上的群岛世界，梦想成为飞行员的少年驾驶自制的滑翔翼，踏上了寻找传说中「天穹尽头」的冒险。广阔的世界观、自由的飞行演出与真挚的友情，构成了这部欧美风冒险动画的独特魅力。",
    featured: false,
  },
  {
    id: "yokai-town",
    title: "妖怪镇物语",
    cover: "https://readdy.ai/api/search-image?query=anime%20supernatural%20key%20visual%20of%20a%20town%20street%20filled%20with%20friendly%20Japanese%20yokai%20spirits%20at%20dusk%2C%20cel%20shaded%20poster%20art%2C%20warm%20orange%20lantern%20glow%2C%20playful%20atmosphere&width=600&height=800&seq=anime-cover-11&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20festival%20night%20in%20a%20spirit%20town%20with%20lanterns%20and%20yokai%20silhouettes%2C%20cel%20shaded%20illustration%2C%20warm%20red%20and%20gold%20lantern%20light%2C%20festive%20mood&width=1600&height=900&seq=anime-banner-11&orientation=landscape",
    genres: ["奇幻", "日常", "治愈"],
    region: "日本",
    year: 2024,
    episodes: 24,
    status: "更新至第 10 集",
    rating: 8.7,
    views: 8770000,
    studio: "百鬼社",
    description:
      "误入妖怪小镇的人类少女，成了唯一能看见妖怪的人类居民。在这里，爱唠叨的河童、开洗衣店的雪女、总爱恶作剧的天狗，都成了她的邻居。轻快幽默的日常之下，藏着一份关于「归属」的温柔。",
    featured: false,
  },
  {
    id: "esports-glory",
    title: "电竞荣光",
    cover: "https://readdy.ai/api/search-image?query=anime%20esports%20key%20visual%20of%20a%20focused%20gamer%20with%20headset%20in%20front%20of%20a%20glowing%20neon%20screen%2C%20cel%20shaded%20poster%20art%2C%20cool%20cyan%20and%20magenta%20lighting%2C%20dynamic%20composition&width=600&height=800&seq=anime-cover-12&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20packed%20esports%20arena%20with%20neon%20screens%20and%20crowd%2C%20cel%20shaded%20illustration%2C%20cyan%20and%20magenta%20stage%20lighting%2C%20high%20energy%20mood&width=1600&height=900&seq=anime-banner-12&orientation=landscape",
    genres: ["热血", "竞技", "校园"],
    region: "国产",
    year: 2023,
    episodes: 20,
    status: "已完结",
    rating: 8.1,
    views: 7320000,
    studio: "巅峰动画",
    description:
      "被职业战队除名的天才少年，在网吧组建了一支没人看好的草根战队。从城市赛一路杀向世界冠军，他们用一场场逆袭证明，热爱从不该被低估。紧张的对局演出与团队成长的群像刻画让人热血沸腾。",
    featured: false,
  },
  {
    id: "hourglass",
    title: "时之沙漏",
    cover: "https://readdy.ai/api/search-image?query=anime%20sci%20fi%20key%20visual%20of%20a%20mysterious%20glowing%20hourglass%20floating%20above%20a%20city%20at%20night%2C%20cel%20shaded%20poster%20art%2C%20deep%20teal%20and%20gold%20tones%2C%20dramatic%20lighting&width=600&height=800&seq=anime-cover-13&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20city%20frozen%20in%20time%20with%20glowing%20clock%20gears%20in%20the%20sky%2C%20cel%20shaded%20illustration%2C%20mysterious%20teal%20and%20gold%20lighting%2C%20suspenseful%20atmosphere&width=1600&height=900&seq=anime-banner-13&orientation=landscape",
    genres: ["悬疑", "科幻", "心理"],
    region: "日本",
    year: 2022,
    episodes: 12,
    status: "已完结",
    rating: 8.9,
    views: 9180000,
    studio: "时序制作",
    description:
      "一名高中生在祖父的遗物中发现了一只能够倒转时间的沙漏。每一次使用都会带来意想不到的代价，而他必须在反复回溯中找出改变命运的正确答案。缜密的伏笔与时间循环的张力，让本作成为悬疑迷的必看之作。",
    featured: false,
  },
  {
    id: "summer-festival",
    title: "夏日烟花祭",
    cover: "https://readdy.ai/api/search-image?query=anime%20romance%20key%20visual%20of%20a%20boy%20and%20girl%20in%20yukata%20watching%20fireworks%20at%20a%20summer%20festival%2C%20cel%20shaded%20poster%20art%2C%20warm%20night%20colors%2C%20nostalgic%20lighting%2C%20gentle%20mood&width=600&height=800&seq=anime-cover-14&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20summer%20night%20festival%20with%20fireworks%20over%20a%20small%20town%20and%20stalls%2C%20cel%20shaded%20illustration%2C%20warm%20festival%20lights%2C%20romantic%20nostalgic%20mood&width=1600&height=900&seq=anime-banner-14&orientation=landscape",
    genres: ["恋爱", "治愈", "青春"],
    region: "日本",
    year: 2021,
    episodes: 12,
    status: "已完结",
    rating: 8.5,
    views: 6540000,
    studio: "夏影社",
    description:
      "在一个充满蝉鸣与烟花的夏天，两个少年少女约定在祭典的最后一晚相见。多年后重逢，他们能否寻回当年那份未曾说出口的心意。淡淡的夏日氛围与细腻的情绪描写，令人回味不尽。",
    featured: false,
  },
  {
    id: "iron-warrior",
    title: "铁血战士传说",
    cover: "https://readdy.ai/api/search-image?query=anime%20action%20key%20visual%20of%20a%20rugged%20warrior%20with%20a%20large%20sword%20in%20a%20desolate%20battlefield%2C%20cel%20shaded%20poster%20art%2C%20gritty%20gray%20and%20red%20tones%2C%20dramatic%20lighting&width=600&height=800&seq=anime-cover-15&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20vast%20war%20torn%20battlefield%20at%20sunset%20with%20armies%20and%20banners%2C%20cel%20shaded%20illustration%2C%20dramatic%20red%20and%20gold%20sky%2C%20epic%20mood&width=1600&height=900&seq=anime-banner-15&orientation=landscape",
    genres: ["热血", "冒险", "战斗"],
    region: "欧美",
    year: 2021,
    episodes: 24,
    status: "已完结",
    rating: 8.0,
    views: 5210000,
    studio: "Ironforge Studio",
    description:
      "在一个被战火撕裂的大陆，一位失去记忆的战士握住了远祖留下的巨剑。为了守护仅存的村庄，他与曾经的宿敌并肩而战。酣畅淋漓的战斗场面与厚重的史诗气质，是欧美动作向动画的代表作。",
    featured: false,
  },
  {
    id: "cat-detective",
    title: "猫耳侦探社",
    cover: "https://readdy.ai/api/search-image?query=anime%20cute%20mystery%20key%20visual%20of%20a%20cat%20eared%20girl%20detective%20with%20a%20magnifier%20in%20a%20cozy%20office%2C%20cel%20shaded%20poster%20art%2C%20warm%20amber%20tones%2C%20charming%20atmosphere&width=600&height=800&seq=anime-cover-16&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20cozy%20detective%20office%20with%20bookshelves%20and%20a%20sleeping%20cat%2C%20cel%20shaded%20illustration%2C%20warm%20amber%20lighting%2C%20inviting%20mood&width=1600&height=900&seq=anime-banner-16&orientation=landscape",
    genres: ["悬疑", "治愈", "日常"],
    region: "日本",
    year: 2024,
    episodes: 12,
    status: "已完结",
    rating: 8.6,
    views: 6890000,
    studio: "软爪社",
    description:
      "在一座安静的小镇里，开着一家专接「怪事」的侦探社。喜欢猫的女主角与她的猫咪助手，用敏锐的观察力解决一桩桩看似鸡毛蒜皮、实则意味深长的谜题。轻松暖心的推理小品，适合睡前观看。",
    featured: false,
  },
  {
    id: "stardust-idol",
    title: "星尘偶像计划",
    cover: "https://readdy.ai/api/search-image?query=anime%20idol%20key%20visual%20of%20a%20girl%20group%20performing%20on%20a%20glowing%20stage%20with%20spotlights%2C%20cel%20shaded%20poster%20art%2C%20vibrant%20pink%20and%20gold%20lights%2C%20energetic%20mood&width=600&height=800&seq=anime-cover-17&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20dazzling%20concert%20stage%20with%20light%20sticks%20and%20crowd%2C%20cel%20shaded%20illustration%2C%20vibrant%20concert%20lighting%2C%20exciting%20mood&width=1600&height=900&seq=anime-banner-17&orientation=landscape",
    genres: ["校园", "音乐", "青春"],
    region: "日本",
    year: 2023,
    episodes: 24,
    status: "已完结",
    rating: 8.3,
    views: 7640000,
    studio: "星光制作",
    description:
      "五个性格迥异的女孩为了同一个舞台梦想走到一起，组成了一支目标直指顶点的偶像组合。汗水、眼泪与友情交织的练习日常，还有一场场燃到炸裂的舞台演出。属于青春与梦想的闪耀物语。",
    featured: false,
  },
  {
    id: "dragon-oath",
    title: "龙裔少年的誓言",
    cover: "https://readdy.ai/api/search-image?query=anime%20fantasy%20key%20visual%20of%20a%20young%20boy%20with%20a%20glowing%20dragon%20mark%20on%20his%20arm%20facing%20a%20huge%20dragon%2C%20cel%20shaded%20poster%20art%2C%20epic%20orange%20and%20blue%20lighting%2C%20dynamic%20composition&width=600&height=800&seq=anime-cover-18&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20giant%20golden%20dragon%20circling%20a%20fantasy%20castle%20at%20sunset%2C%20cel%20shaded%20illustration%2C%20epic%20scale%2C%20warm%20golden%20light%2C%20fantasy%20adventure%20mood&width=1600&height=900&seq=anime-banner-18&orientation=landscape",
    genres: ["奇幻", "热血", "冒险"],
    region: "国产",
    year: 2022,
    episodes: 26,
    status: "已完结",
    rating: 8.2,
    views: 6180000,
    studio: "苍龙动画",
    description:
      "背负龙裔血脉的少年被村庄驱逐，却因此踏上了寻找龙族起源的旅途。当古老的誓言被重新唤醒，他必须决定是复仇还是守护。宏大的奇幻世界观与热血的口号，让这部国漫收获了大批粉丝。",
    featured: false,
  },
  {
    id: "cloud-library",
    title: "云端图书馆",
    cover: "https://readdy.ai/api/search-image?query=anime%20whimsical%20key%20visual%20of%20an%20endless%20floating%20library%20among%20clouds%20with%20flying%20books%2C%20cel%20shaded%20poster%20art%2C%20soft%20lavender%20and%20gold%20tones%2C%20dreamy%20atmosphere&width=600&height=800&seq=anime-cover-19&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20vast%20floating%20library%20among%20golden%20clouds%20at%20sunrise%2C%20cel%20shaded%20illustration%2C%20soft%20pastel%20sky%2C%20dreamy%20serene%20mood&width=1600&height=900&seq=anime-banner-19&orientation=landscape",
    genres: ["治愈", "奇幻", "文艺"],
    region: "日本",
    year: 2024,
    episodes: 12,
    status: "更新至第 9 集",
    rating: 9.1,
    views: 10350000,
    studio: "云笺社",
    description:
      "在一座漂浮于云海之上的图书馆里，收藏着世间所有被人遗忘的故事。沉默的图书管理员与前来借书的神秘访客之间，展开了一段关于记忆与告别的静谧旅程。诗意盎然的画面与隽永的情感，是年度口碑最高的文艺治愈系作品。",
    featured: true,
  },
  {
    id: "deep-echo",
    title: "深海回声",
    cover: "https://readdy.ai/api/search-image?query=anime%20sci%20fi%20key%20visual%20of%20a%20lone%20diver%20in%20a%20deep%20underwater%20facility%20with%20glowing%20lights%2C%20cel%20shaded%20poster%20art%2C%20deep%20blue%20and%20cyan%20tones%2C%20eerie%20atmosphere&width=600&height=800&seq=anime-cover-20&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20vast%20deep%20sea%20research%20facility%20glowing%20in%20the%20dark%20ocean%2C%20cel%20shaded%20illustration%2C%20deep%20blue%20and%20cyan%20bioluminescence%2C%20mysterious%20mood&width=1600&height=900&seq=anime-banner-20&orientation=landscape",
    genres: ["科幻", "悬疑", "惊悚"],
    region: "日本",
    year: 2023,
    episodes: 13,
    status: "已完结",
    rating: 8.6,
    views: 7990000,
    studio: "深蓝制作",
    description:
      "一支深海科考队在万米海沟中发现了一段无法解释的回声信号。随着调查深入，队员们开始听见本不该存在的声音。密闭空间的压迫感与层层反转的剧情，让它成为近年最出色的深海科幻悬疑番。",
    featured: false,
  },
  {
    id: "rose-knights",
    title: "蔷薇骑士团",
    cover: "https://readdy.ai/api/search-image?query=anime%20fantasy%20key%20visual%20of%20a%20group%20of%20knights%20in%20ornate%20armor%20with%20rose%20emblems%2C%20cel%20shaded%20poster%20art%2C%20regal%20red%20and%20gold%20tones%2C%20noble%20atmosphere&width=600&height=800&seq=anime-cover-21&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20grand%20medieval%20kingdom%20with%20a%20rose%20garden%20and%20castle%2C%20cel%20shaded%20illustration%2C%20regal%20red%20and%20gold%20tones%2C%20majestic%20mood&width=1600&height=900&seq=anime-banner-21&orientation=landscape",
    genres: ["冒险", "热血", "奇幻"],
    region: "欧美",
    year: 2024,
    episodes: 12,
    status: "更新至第 7 集",
    rating: 8.4,
    views: 5760000,
    studio: "Rosewood Studio",
    description:
      "在大陆最强的骑士团中，五位性格各异的团员为了守护王国并肩作战。当背叛的阴影笼罩王国，他们必须在荣誉与真相之间做出抉择。华丽的骑士设定与紧凑的剧情推进，令人欲罢不能。",
    featured: false,
  },
  {
    id: "bento-girl",
    title: "便当少女的日常",
    cover: "https://readdy.ai/api/search-image?query=anime%20slice%20of%20life%20key%20visual%20of%20a%20cheerful%20girl%20holding%20a%20colorful%20bento%20box%20in%20a%20sunny%20classroom%2C%20cel%20shaded%20poster%20art%2C%20soft%20warm%20pastel%20colors%2C%20cozy%20mood&width=600&height=800&seq=anime-cover-22&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20sunny%20high%20school%20classroom%20with%20open%20windows%20and%20cherry%20petals%2C%20cel%20shaded%20illustration%2C%20soft%20warm%20afternoon%20light%2C%20cozy%20nostalgic%20mood&width=1600&height=900&seq=anime-banner-22&orientation=landscape",
    genres: ["治愈", "校园", "日常"],
    region: "日本",
    year: 2022,
    episodes: 12,
    status: "已完结",
    rating: 8.0,
    views: 4870000,
    studio: "午後社",
    description:
      "每天早上，少女都会为自己和同学们准备一份充满心意的便当。透过一份份便当，串起了校园里平凡却温暖的小小故事。朴实温柔的画风与慢节奏的日常，让人不自觉地露出微笑。",
    featured: false,
  },
  {
    id: "illusion-chess",
    title: "幻境棋士",
    cover: "https://readdy.ai/api/search-image?query=anime%20fantasy%20key%20visual%20of%20a%20young%20chess%20player%20with%20glowing%20magical%20chess%20pieces%20floating%20around%2C%20cel%20shaded%20poster%20art%2C%20purple%20and%20gold%20lighting%2C%20strategic%20intense%20mood&width=600&height=800&seq=anime-cover-23&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20giant%20magical%20chessboard%20arena%20with%20glowing%20pieces%20and%20crowd%2C%20cel%20shaded%20illustration%2C%20mystical%20purple%20and%20gold%20lighting%2C%20epic%20duel%20mood&width=1600&height=900&seq=anime-banner-23&orientation=landscape",
    genres: ["奇幻", "竞技", "热血"],
    region: "国产",
    year: 2024,
    episodes: 24,
    status: "更新至第 18 集",
    rating: 8.5,
    views: 8410000,
    studio: "星阵动画",
    description:
      "在这个世界，棋局不仅是智力的较量，更是召唤幻兽参战的对决。天赋异禀的少年带着祖父留下的旧棋盘，向被誉为「不可战胜」的棋王发起挑战。烧脑的战术博弈与炫目的幻境对战，堪称国漫竞技番的黑马。",
    featured: false,
  },
  {
    id: "doomsday-lightyear",
    title: "末日光年",
    cover: "https://readdy.ai/api/search-image?query=anime%20sci%20fi%20key%20visual%20of%20a%20lone%20astronaut%20floating%20before%20a%20dying%20planet%2C%20cel%20shaded%20poster%20art%2C%20dramatic%20orange%20and%20dark%20blue%20tones%2C%20epic%20lonely%20mood&width=600&height=800&seq=anime-cover-24&orientation=portrait",
    banner: "https://readdy.ai/api/search-image?query=anime%20background%20of%20a%20vast%20space%20scene%20with%20a%20dying%20earth%20and%20scattered%20spaceships%2C%20cel%20shaded%20illustration%2C%20dramatic%20orange%20and%20deep%20blue%20nebula%2C%20epic%20melancholic%20mood&width=1600&height=900&seq=anime-banner-24&orientation=landscape",
    genres: ["科幻", "冒险", "剧情"],
    region: "日本",
    year: 2023,
    episodes: 24,
    status: "已完结",
    rating: 8.8,
    views: 9350000,
    studio: "光年制作",
    description:
      "当母星即将走向终结，人类把最后的希望寄托在一艘驶向深空的光速飞船上。船上的人们一边寻找新的家园，一边面对着冰冷的宇宙与内心的孤独。恢弘的宇宙尺度与深沉的人文思考，让本作被誉为年度科幻神作。",
    featured: false,
  },
];

export const genreOptions = [
  "热血",
  "恋爱",
  "冒险",
  "奇幻",
  "校园",
  "科幻",
  "悬疑",
  "治愈",
  "日常",
  "竞技",
];

export const regionOptions = ["日本", "国产", "欧美"];

export const yearOptions = [2024, 2023, 2022, 2021];

export const sortOptions = [
  { value: "latest", label: "最新上传" },
  { value: "hot", label: "按热度" },
  { value: "rating", label: "按评分" },
];